import { Component, OnInit, Input, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LookUpService } from '../../../services/lookupservice';
import { HttpErrorResponse } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { SiteLockCodes, SiteLockCodesDialogData } from '../../../interfaces/sitelockcodes';
import { NotificationService } from '../../../services/notificationservice';

@Component({
  selector: 'app-sitelockcodes-popup',
  standalone: true,
  imports: [
    MatCardModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    CommonModule
  ],
  templateUrl: './sitelockcodes.component.html',
  styleUrl: './sitelockcodes.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SitelockcodesComponent implements OnInit {

  receivedSiteId: string | null = null;
  siteName: string = '';
  lockCodes: SiteLockCodes[] = [];
  hydrolyzerValue: number | null = null;
  greenValue: number | null = null;
  yellowValue: number | null = null;
  redValue: number | null = null;
  solidsValue: number | null = null;
  hydrolyzerLabel: string = 'Hydrolyzer';
  greenTankLabel: string = 'Green';
  yellowTankLabel: string = 'Yellow';
  redTankLabel: string = 'Red';
  solidsTankLabel: string = 'Solids';

  constructor(
    private notificationService: NotificationService,
    public dialogRef: MatDialogRef<SitelockcodesComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: SiteLockCodesDialogData,
    private lookupService: LookUpService
  ) {
    console.log(this.inputData);
    this.receivedSiteId = this.inputData.data.siteId;
    this.siteName = this.inputData.data.siteName;
  }

  ngOnInit(): void {
    if (this.receivedSiteId !== null) {
      var siteid = this.receivedSiteId;
      siteid = siteid.split('-')[1]; // Extract numeric part after 'VRS-'
      this.lookupService.getLockCodesBySitesId(siteid).subscribe({
        next: (res: SiteLockCodes[]) => {
          console.log(res);
          this.lockCodes = res;

          if (res && res.length > 0) {
            if (this.receivedSiteId === "VRS-2" || this.receivedSiteId === "VRS-4") {
              
              res.forEach(code => {
                switch (code.tankName) {
                  case "Red":
                    this.redValue = this.convertToNumber(code.siteLockCode);
                    break;
                  case "Yellow":
                    this.yellowValue = this.convertToNumber(code.siteLockCode);
                    break;
                  case "Green":
                    this.greenValue = this.convertToNumber(code.siteLockCode);
                    break;
                  case "Solids":
                    this.solidsValue = this.convertToNumber(code.siteLockCode);
                    break;
                }
              });              
              this.hydrolyzerValue = null;

            } else {
              if (res.length === 1 && res[0].siteLockCode !== undefined) { 
                this.hydrolyzerValue = this.convertToNumber(res[0].siteLockCode);
              } else if (res.length > 1) {
                const hydrolyzerCode = res.find(code => code.tankName === "Hydrolyzer");
                if (hydrolyzerCode) {
                    this.hydrolyzerValue = this.convertToNumber(hydrolyzerCode.siteLockCode);
                } else {
                    this.hydrolyzerValue = this.convertToNumber(res[0].siteLockCode);
                }
              }
              this.redValue = null;
              this.yellowValue = null;
              this.greenValue = null;
              this.solidsValue = null;
            }
          } else {

            this.hydrolyzerValue = null;
            this.greenValue = null;
            this.yellowValue = null;
            this.redValue = null;
            this.solidsValue = null;

            this.notificationService.show("No lock codes found for the selected site.", 'warning')
            this.onCloseClick();
          }
        }
      });
    }
  }

  convertToNumber(value: string | undefined): number | null{
      const num = parseFloat(value || '');
      return isNaN(num) ? null : num;
    };

  onCloseClick(): void {
    this.dialogRef.close(false);
  }
  close(){
    
  }
}
